import styled from 'styled-components'
import { COLORS } from 'utils'

export const RedLine = styled.div`
  background-color: ${COLORS.error};
  border: ${COLORS.error} solid 2px;
`
